import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

export interface PersonReview {
  name: string;
  rating: number;
  comment: string;
  date: string;
  avatar?: string;
}

@Component({
  selector: 'app-comments-modal',
  standalone: false,
  templateUrl: './comments-modal.html',
  styleUrl: './comments-modal.scss'
})
export class CommentsModal {
  @Input() reviews: PersonReview[] = [];

  constructor(public activeModal: NgbActiveModal) { }

  get averageRating(): number {
    if (!this.reviews.length) return 0;

    const total = this.reviews.reduce(
      (sum, review) => sum + review.rating,
      0
    );

    return total / this.reviews.length;
  }

  getStars(rating: number): number[] {
    return Array.from(
      { length: 5 },
      (_, index) => index + 1
    );
  }

  getRatingCount(star: number): number {
    return this.reviews.filter(
      review => Math.floor(review.rating) === star
    ).length;
  }

  getRatingPercentage(star: number): number {
    if (!this.reviews.length) return 0;

    return (this.getRatingCount(star) / this.reviews.length) * 100;
  }

}
